import { useContext } from "react";
import SessionPreferencesContext from "./SessionPreferencesContext";

function useSessionPreferences() {
    const context = useContext(SessionPreferencesContext);

    if (!context) {
        throw new Error(
            "useSessionPreferences must be used within a SessionPreferencesProvider",
        );
    }

    return context;
}

export default useSessionPreferences;
